import React from 'react'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  helperText?: string
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  className = '',
  ...props
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label className="text-sm font-medium text-text-primary">
          {label}
        </label>
      )}
      <input
        className={`
          px-3 py-2 rounded-md
          bg-background-tertiary
          border border-zinc-700
          text-text-primary
          placeholder:text-text-muted
          focus:outline-none focus:ring-2 focus:ring-accent-primary focus:border-transparent
          disabled:opacity-50 disabled:cursor-not-allowed
          ${error ? 'border-accent-danger' : ''}
          ${className}
        `}
        {...props}
      />
      {error && (
        <span className="text-sm text-accent-danger">{error}</span>
      )}
      {helperText && !error && (
        <span className="text-sm text-text-muted">{helperText}</span>
      )}
    </div>
  )
}

export default Input
